<!-- 由 suu 创建于 2021-08-11 星期三 -->
<template>
  <div
    class="subscribe"
    :style="{
      paddingTop: height + 'px'
    }"
  >
    <div
      class="sub-bar"
      v-if="isApp"
      :style="{
        height: height + 'px',
        paddingTop: statusBarHeight + 'px'
      }"
    >
      <div class="back" @click="bindBack"
        ><i class="iconfont icon-you"></i
      ></div>
      <div class="title">课程预约</div>
      <!-- 3.0.1才显示 -->
      <!-- <div class="right" @click="handleOpenRecoPop" v-if="window.onCoursePreferenceSave">约课偏好</div> -->
      <div
        class="right"
        @click="handleOpenRecoPop"
        v-if="isShowRecommendCoachUser"
        >约课偏好</div
      >
    </div>
    <!-- <router-view
      class="
        animate__animated
        animate__fadeInRight
        animate__fast
      "
    /> -->
    <!-- <router-view /> -->
    <template v-if="home">
      <!-- 协议 -->
      <template
        v-if="
          !agreementInfo['is_reservation_class'] ||
          agreementInfo['is_reservation_class'] != 1
        "
      >
        <!-- 轮播 -->
        <div class="sub-swipe" v-if="showCoachProve">
          <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
            <!-- 23年疫情广播 -->
            <van-swipe-item>
              <router-link
                :to="{ path: 'coach-prove-2023', query: { sfrom: 'banner' } }"
              >
                <img
                  class="banner-img"
                  src="https://cdnvue.gymcity.com.cn/uploads/23-coach-prove-banner"
                  alt=""
                />
              </router-link>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 日期列表 -->
        <div
          class="WeDateTab-wrap"
          :style="{
            top: height + 'px'
          }"
        >
          <WeDateTab
            :dayInfo="dayinfo"
            :activedDate="currDay"
            @dateChange="onDateChange($event, false)"
            tfrom="subscribe"
          ></WeDateTab>
        </div>
        <!-- 25年春节放假 -->
        <img
          class="spring-day-2023"
          style="width: 100%; margin-top: 2px"
          v-if="showSpringDay"
          :src="showSpringDay"
          alt=""
        />
        <template v-else>
          <!-- 城市 时间切换 -->
          <WeCitySelect
            from="subscribe"
            @citySelect="onCitySelect"
            @timeSelect="onTimeSelect"
          ></WeCitySelect>
          <!-- 已预约课程 -->
          <CourseReserved
            :list="courseRe"
            v-if="courseRe && courseRe.length"
          ></CourseReserved>
          <!-- 偏好教练推荐 仅App展示 筛选时段或非会籍城市时隐藏 -->
          <RecommendCoach
            v-if="isShowRecommendCoachUser && !hasCurrDayCourse"
            ref="recommendCoach"
            :day="currDay"
            :hidden="!showRecommendCoach"
          ></RecommendCoach>
          <!-- 对应门店列表 -->
          <van-collapse
            accordion
            class="shop-list mod_grid"
            :border="false"
            v-model="shopActiveIndex"
            @change="handleCollapseChange"
          >
            <template v-for="(shop, shopkey, shopIndex) in currdataFilter">
              <van-collapse-item :key="shopIndex" :name="shopIndex" v-if="shop">
                <template #title>
                  <div class="shop-title">
                    {{ shop.shop_name }}
                    <!-- 点击日期切换 请求接口时不显示 -->
                    <template v-if="showShopSpecState">
                      <span class="t-near" v-if="shop.is_near">距您最近</span>
                      <span
                        v-if="
                          showCloseShopTitle(shop.shop_name) &&
                          (closeShopShowObject[shop.shop_name].isCover ||
                            (!closeShopShowObject[shop.shop_name].isCover &&
                              Object.keys(shop).length < showIsClose(shop) &&
                              !shop['is_class']))
                        "
                        class="shop-close-new"
                        >{{ closeShopShowObject[shop.shop_name].title }}</span
                      >
                    </template>
                  </div>
                </template>
                <!-- 门店课程列表 -->
                <template
                  v-if="
                    !(
                      showCloseShopTitle(shop.shop_name) &&
                      closeShopShowObject[shop.shop_name].isCover
                    )
                  "
                >
                  <template v-for="(course, coursekey, courseIndex) in shop">
                    <CourseItem
                      @appoint="goDetail(course)"
                      @head-click="handleHeadBox"
                      :showMxPopId="showMxPopId"
                      :info="course"
                      :isZqj="isZqj"
                      :coachTestList="coachTestList"
                      v-if="isShowCourse(course)"
                      :key="courseIndex"
                      ref="CourseItem"
                    >
                    </CourseItem>
                  </template>
                </template>
                <!-- 店铺列表对象 至少有个一个字段为shop_name  有定位的时候会多一个字段 is_near-->
                <!-- 防止传时间段筛选时该时间段没有排课信息也显示疫情闭馆信息， home接口传了时间字段时 返回is_class字段 表示当天整天该门店是否有排课 1有 0没有 -->
                <!-- is_class 为false时才显示 闭馆信息 -->
                <div
                  class="course-list-no"
                  v-if="
                    Object.keys(shop).length < showIsClose(shop) ||
                    (showCloseShopTitle(shop.shop_name) &&
                      closeShopShowObject[shop.shop_name].isCover)
                  "
                >
                  <!-- 部分门店闭关通知 -->
                  <template
                    v-if="
                      !shop['is_class'] && showCloseShopTitle(shop.shop_name)
                    "
                  >
                    <!-- 提示图片 -->
                    <template
                      v-if="closeShopShowObject[shop.shop_name].showImg"
                    >
                      <img
                        class="tips tips-img"
                        :src="closeShopShowObject[shop.shop_name].showImg"
                      />
                      <div
                        class="tips-img-btn"
                        @click="handleKyShopImgClick(shop.shop_name)"
                      ></div>
                      <div
                        class="tips-img-btn tips-img-btn-2"
                        v-if="closeShopShowObject[shop.shop_name].showShare"
                        @click="handleKyShopImgClickShare(shop.shop_name)"
                      ></div>
                    </template>
                    <!-- 提示文字 -->
                    <div
                      v-else
                      class="tips mz-tips"
                      v-html="closeShopShowObject[shop.shop_name].showText"
                    />
                  </template>
                  <div v-else>暂无可约课程</div>
                </div>
                <!-- 是否显示隐藏的课程 -->
                <div
                  class="shop-hide-switch"
                  v-else-if="isShowHiddenCourseShop(shop)"
                >
                  <div
                    class="switch-btn"
                    @click="handleShowHiddenCourseSwitch(shop)"
                    ><div class="btn-coach-imgs"
                      ><img
                        class="coach-img"
                        v-for="(item, index) in hiddenCourseObj[
                          shop['shop_name']
                        ].slice(0, 3)"
                        :src="
                          item + '?x-oss-process=image/resize,m_fill,h_50,w_50'
                        "
                        :key="index"
                        alt="" /></div
                    >查看门店全部教练<van-icon
                      class="shop-hide-switch-icon"
                      name="arrow-down"
                  /></div>
                  <div class="switch-tips"
                    >为您优先展示近期活跃、与您匹配度更高的教练，方便快速预约</div
                  >
                </div>
              </van-collapse-item>
            </template>
          </van-collapse>
          <!-- 实名认证入口 多门店约课 -->
          <img
            v-if="user.user.uid != '-1' && user.user.cdcard === false"
            class="dmd-img"
            @click="handleDmdImgClick"
            src="https://cdnvue.gymcity.com.cn/uploads/dmd-banner"
            alt=""
          />
          <!-- 等级弹窗 -->
          <MemberGradePop
            v-if="showGradePop"
            :popInfo="gardePopInfo"
            @on-close="closePop('showGradePop')"
          >
          </MemberGradePop>
          <!-- 勋章弹窗 -->
          <MemberMedalPop
            v-if="showMedalPop"
            :list="medalPopList"
            :user="user.user"
            @on-close="closePop('showMedalPop')"
          />
          <!-- 首商首次约课 特殊停卡提醒弹窗 -->
          <SpecialStopCardPop
            v-if="showSpecialStopCardPop"
            @on-close="closePop('showSpecialStopCardPop')"
          />
          <!-- 专属训练规划师更换提醒弹窗 -->
          <MainCoachPop
            :visible.sync="mainCoachShow"
            :coachNew="coachNew"
            :coachOld="coachOld"
          />
        </template>
        <!-- 非单店卡切换城市弹窗 -->
        <BtwMessageBox
          v-if="showCityChangeTips"
          :title="cityTipsMessageBoxObj.title"
          :message="cityTipsMessageBoxObj.message"
          messageFontSize="3.46vw"
          :showCancelButton="cityTipsMessageBoxObj.showCancelButton"
          :confirmText="cityTipsMessageBoxObj.confirmText"
          :confirmFn="cityTipsMessageBoxObj.confirmFn"
        ></BtwMessageBox>
      </template>
      <!-- 会员协议 -->
      <AgreementSigning
        v-if="showAgreSignPop"
        :scene="1"
        :popInfo="agreementInfo"
        :isYyxz="agreementYyxz"
        @on-close="showAgreSignPop = false"
      ></AgreementSigning>
      <!-- 会员生日弹窗 -->
      <birthdayPop
        v-if="showBirthdayPop"
        :popInfo="memberBirthdayInfo"
        @close="closePop('showBirthdayPop')"
      >
      </birthdayPop>
    </template>
    <SubSkeleton v-else></SubSkeleton>
    <!-- <vLoading v-else></vLoading> -->
  </div>
</template>

<script>
import WeDateTab from '@/components/WeDateTab.vue' // 日期栏
import WeCitySelect from '@/components/WeCitySelect.vue' // 城市选择
import CourseItem from './ponents/CourseItem.vue' // 课程列表
import CourseReserved from './ponents/CourseReserved.vue' // 已预约课程
import RecommendCoach from './ponents/RecommendCoach.vue' // 偏好教练推荐
import AgreementSigning from './ponents/agreement-signing.vue' // 会员协议签署提醒弹窗
import MemberGradePop from './ponents/MemberGradeUpPop.vue' // 等级弹窗
import MemberMedalPop from './ponents/MemberMedalPop.vue' // 勋章弹窗
import SpecialStopCardPop from './ponents/SpecialStopCardPop.vue' // 首商首次约课 特殊停卡提醒弹窗
import MainCoachPop from './ponents/MainCoachPop.vue' // 专属训练规划师更换提醒弹窗
import SubSkeleton from './ponents/SubSkeleton.vue' // 约课列表骨架屏
import { mapState } from 'vuex'
import birthdayPop from './ponents/birthday-pop.vue'
import BtwMessageBox from '@/components/BtwMessageBox.vue' // 切换城市弹窗
import { set } from 'lodash'
export default {
  name: 'subscribe',

  components: {
    WeDateTab,
    CourseItem,
    CourseReserved,
    RecommendCoach,
    WeCitySelect,
    AgreementSigning,
    MemberGradePop,
    MemberMedalPop,
    SpecialStopCardPop,
    MainCoachPop,
    SubSkeleton,
    birthdayPop,
    BtwMessageBox
  },

  props: {},

  data() {
    return {
      watchUserDone: false, // 用户信息监听并直接相关函数完成
      showPoping: false, // 弹窗展示状态
      statusBarHeight: 0,
      height: 0,
      shopActiveIndex: 0, // 门店列表默认打开的项
      currDay: {
        // 当前日期对象
        week: null,
        a_day: null,
        day: null
      },
      // 需要显示闭馆 新店开业预热的门店配置
      closeShopShowObject: {
        北辰荟私教馆: {
          startTime: '2026/09/25', // 开始时间  没有立即开始
          endTime: '2026/10/08',
          showImg:
            'https://gympic.gymcity.com.cn/uploads-add/202609/closeNotice-cs-bch',
          title: '装修升级，临时闭馆',
          isCover: false
        },
        雨花客厅私教馆: {
          startTime: '2026/09/23', // 开始时间  测试环境提前到9月20
          endTime: '2026/09/25',
          showImg:
            'https://gympic.gymcity.com.cn/uploads-add/202609/closeNotice-nj-yhkt-260922',
          title: '安全检查，临时闭馆',
          isCover: false
        },
        龙江尚悦天地私教馆: {
          endTime: '2026/01/25',
          showImg: 'https://cdnvue.gymcity.com.cn/uploads/newsre-bg-ljsytd?v=1',
          title: '新店开业，敬请期待！'
        },
        后海皇庭港湾私教馆: {
          startTime: '2026/10/21', // 开始时间
          endTime: '2026/10/24',
          showImg:
            'https://gympic.gymcity.com.cn/uploads-add/202610/closeNotice-hhhtgw-261016',
          title: '装修升级，临时闭馆',
          isCover: false
        },
        科苑金地威新私教馆: {
          startTime: '2026/10/01', // 开始时间  测试环境提前到9月20
          endTime: '2026/10/02',
          showImg:
            'https://gympic.gymcity.com.cn/uploads-add/202609/closeNotice-shenzhen-kyxdw-260923',
          title: '停电检修，临时闭馆',
          isCover: false,
          showShareBtn: false // 是否显示分享按钮  新店转介活动已上线 开启
          // showShareBtn: true, // 是否显示分享按钮  新店转介活动已上线 开启
          // shareParams: 'new-shop-share-246',
          // sharePageTitle: '科苑金地威新私教馆新店开业'
        },
        香蜜湖私教馆: {
          endTime: '2026/11/01',
          showImg:
            'https://gympic.gymcity.com.cn/uploads-add/202607/newsre-bg-xmh?v=2',
          title: '11月1日新店开业',
          isCover: false,
          showShareBtn: false, // 是否显示分享按钮  新店转介活动已上线 开启
          shareParams: 'new-shop-share-245'
        },
        月湖芒果私教馆: {
          startTime: '2026/02/04', // 开始时间  没有立即开始
          endTime: '2026/02/05', // 结束时间
          showImg: '', // 显示图片 优先判断显示
          // 显示文案
          showText: `<div>
        亲爱的健萌er： <br/>
        因健萌特殊工作安排，月湖芒果馆将于2月4日（周三）闭馆一天。<br/>
        为保障您的权益，月湖芒果馆的会员卡统一暂停1天，不会造成会员卡时长浪费。<br/>
        给您带来的不便敬请谅解，感谢您对我们工作的支持！如有疑问可联系您的主教练或店长咨询~
        </div>`,
          title: '场馆今日休息中', // 门店名称后面提醒
          isCover: false // 当天有排课也不显示排课显示配置图片或文案
        }
      }, // 即将开业 预上线 结束时间
      showShopSpecState: true, // 显示门店特殊状态  由于接口的形式 在切换日期的时候会判断排课为空 所以切换时不显示状态 请求完接口再判断
      requestedDates: new Set(), // 记录已经请求过数据的日期
      showMxPopId: '', // 当前显示萌新导师定义弹窗的教练id
      coachTestList: [],
      showAgreSignPop: false, // 会员协议签署提醒弹窗
      agreementInfo: {}, // 未签协议被限制约课
      agreementYyxz: false, // 点击预约课程时提示弹窗（场景为点击预约超过签署协议截止日期后的课程）
      showGradePop: false, // 显示等级弹窗
      gardePopInfo: {}, // 等级弹窗信息
      showMedalPop: false, // 显示勋章弹窗
      medalPopList: [], // 勋章弹窗信息
      showSpecialStopCardPop: false, // 首商首次约课 特殊停卡提醒弹窗
      mainCoachShow: false, // 专属训练规划师更换提醒弹窗
      coachNew: {}, // 新规划师
      coachOld: {}, // 旧规划师
      isShowHiddenCourseShopObj: {}, // 是否显示隐藏的课程 （无剩余课 或 v4v5v6隐藏高级教练 https://docs.qq.com/doc/DT1VNdFJYSVNGd2dQ）
      hiddenCourseObj: {}, // 隐藏的课程对象
      isLoadingHome: false, // 是否正在请求home接口，用于控制hiddenCourseObj的更新
      showBirthdayPop: false, //会员弹窗
      memberBirthdayInfo: null,
      showCityChangeTips: false, // 显示城市切换提醒弹窗
      cityTipsMessageBoxObj: {
        title: '提示',
        message: '',
        showCancelButton: false,
        confirmText: '确定',
        confirmFn: () => {}
      },
      showCoursePreferencePop: false // 显示APP原生偏好教练设置弹窗
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    },
    // 中秋节
    isZqj() {
      const cur = new Date(this.currDay.a_day.replace(/-/g, '/'))
      return cur >= new Date('2024/09/15') && cur < new Date('2024/09/18')
    },
    ...mapState('coachProve', ['start', 'end']),
    // 闭馆通知
    showSpringDay() {
      const config = this.$store.state.closeNotice
      if (
        new Date(this.currDay.a_day.replace(/-/g, '/')).getTime() <
          new Date(config.startDate).getTime() ||
        new Date(this.currDay.a_day.replace(/-/g, '/')).getTime() >=
          new Date(config.endDate).getTime() ||
        !config.regionIds.includes(
          Number(this.user.user.current_city.region_id)
        )
      ) {
        return false
      }
      return config.noticeImg
    },
    // 选择的时段
    curTime() {
      let curTime = this.$store.state.subscribe.curTime
      let temp = []
      curTime.map((v) => {
        temp.push(v.slice(0, 2))
      })
      let hT = temp.join(',')
      if (hT === '不限') hT = ''
      return hT
    },
    // 定位经纬度
    location() {
      return this.$store.state.location || { lat: '', lng: '' }
    },
    // 上方日期栏信息
    dayinfo() {
      return this.$store.state.subscribe.dayinfo
    },
    // 当前已预约课程
    courseRe() {
      return this.$store.state.subscribe.course
    },
    // 门店列表排课数据
    currdata() {
      return this.home[this.currDay['a_day']] || {}
    },
    // home
    home() {
      if (Object.keys(this.$store.state.subscribe.home).length) {
        // 只在 currDay 未设置时设置默认日期
        if (!this.currDay.a_day) {
          this.currDay = this.dayinfo[0]
        }
        // 记录当前日期已经请求过（因为store中有数据说明已经请求过）
        this.requestedDates.add(this.currDay.a_day)
      }
      return this.$store.state.subscribe.home
    },
    user() {
      return this.$store.state.user || null
    },
    // 非正式会员或21天卡会员(34 21天卡  35 21天体验卡)  会员不显示推荐教练
    // 插了 34 的21天卡是正式会员 未激活也不显示
    isShowRecommendCoachUser() {
      // 接口数据未返回时默认不显示
      if (!this.user || !this.user.user) {
        return false
      }
      // 非正式会员或21天卡类型 → 隐藏
      let temp =
        this.user.user.member_state == 0 ||
        [34, 35].includes(this.user.user.current_card_type * 1)
      // 有未激活的21天卡 → 隐藏
      if (!temp && this.user.user.card && this.user.user.card.length) {
        temp = this.user.user.card.some((v) => {
          return [34, 35].includes(v.card_id * 1) && v.card_state == 0
        })
      }
      return !temp
    },
    // 是否是减脂营用户
    isGcUser() {
      return (
        this.$store.state.user.user.gc_state * 1 === 1 &&
        !this.$route.query.isreduce
      )
    },
    // 是否是体验会员并且没有约过课
    isExpUserFirst() {
      if (
        this.user &&
        this.user.user &&
        this.user.user.allow_class_fast &&
        this.user.user.is_exp_user
      ) {
        return true
      }
      return false
    },
    showCoachProve() {
      const now = new Date().getTime()
      if (
        now >= new Date(this.start).getTime() &&
        now < new Date(this.end).getTime()
      ) {
        return true
      }
      return false
    },
    currdataFilter() {
      const result = Object.keys(this.currdata).reduce((acc, v) => {
        if (this.currdata[v].shop_name) {
          acc[v] = this.currdata[v]
        }
        return acc
      }, {})
      return result
    },
    // 当前日期是否已有约课
    hasCurrDayCourse() {
      if (!this.courseRe || !this.courseRe.length) return false
      if (!this.currDay || !this.currDay.a_day) return false
      return this.courseRe.some((item) => item.day === this.currDay.a_day)
    },
    // 是否展示偏好教练推荐：仅默认状态(未筛选时段 且 当前为会籍城市) 且 App环境
    showRecommendCoach() {
      // if (!this.isApp) return false
      // 筛选了时段 则隐藏
      if (this.curTime) return false
      // 当前城市非会籍城市 则隐藏
      const curCity = this.$store.state.curCity
      const userRegionId =
        this.user && this.user.user && this.user.user.region_id
      if (userRegionId && curCity && curCity.region_id != userRegionId) {
        return false
      }
      return true
    }
  },

  watch: {
    isGcUser(nv) {
      if (nv) {
        this.$router.replace('fat-reduction')
      }
    },
    isExpUserFirst(nv) {
      // 是体验会员 并且当前激活的卡没有约课记录 则跳转到 体验卡领卡成功问卷页
      if (nv) {
        this.$http._toVueH5Url('get-card-success')
      }
    },
    home(nv) {
      // 要等全局接口请求完当前天全部数据再判断，不然当前天全部数据接口返回可能会慢于第二天数据接口
      // 判断是否需要请求传入日期或第二天数据
      this.checkAndLoadDateData()
    },
    user: {
      handler(nv) {
        if (nv && nv.user && !this.watchUserDone) {
          this.watchUserDone = true
          // 依赖用户信息相关函数
          this.showCoachChangePop()
          // 获取勋章弹窗信息
          this.getIsShowMedalPop()
        }
      },
      deep: true,
      immediate: true
    },
    currdataFilter(nv) {
      if (nv && Object.keys(nv).length) {
        this.autoShowShop()
      }
    }
  },

  created() {
    // 页面初始化时 获取状态栏高度
    this.getBottomContentHeight()
    // 获取会员协议签署信息
    this.getAgreementSigning()
    // 获取特殊停卡提醒弹窗状态
    this.getSpecialStopCardPop()
    // 获取等级弹窗信息
    this.getIsShowGradePop()
    //会员生日弹窗
    this.getShowBirthdayPop()
    // app 页面恢复时 重新获取状态
    window.onPageResumed = () => {
      // 判断从后台回到前台判断当前天和列表第一天是否匹配，不匹配则刷新页面
      if (
        this.dayinfo &&
        this.dayinfo.length &&
        new Date().setHours(0, 0, 0, 0) !==
          new Date(this.dayinfo[0].a_day.replace(/-/g, '/')).getTime()
      ) {
        console.log('重新获取数据')
        // this.currDay = {
        //   week: null,
        //   a_day: null,
        //   day: null
        // }
        // this.$http.homeinfo('', '', this.$store.state.curCity.region_id)
        // this.$http.userinfo('', '', this.$store.state.curCity.region_id)
        // if (this.$route.name !== 'subscribe') {
        //   this.$router.back()
        // }
        // location.replace(location.href)
        this.$toast('数据已过期')
        setTimeout(() => {
          this.$betterwe.onAppCloseRoute()
          this.$betterwe.jumpRoute(
            `/web?isJM=1&isAddToken=false&isShowTitle=false&url=${
              location.origin + '/subscribe'
            }`
          )
        }, 1000)
      } else {
        // 如果是偏好设置弹窗则这里不请求
        if (this.showCoursePreferencePop) {
          this.showCoursePreferencePop = false
          return
        }
        this.$http.userinfo('', '', this.$store.state.curCity.region_id)
        // 如果是约课列表 则显示加载中 subscribe/detail教练主页 则不显示
        this.onDateChange(
          this.currDay,
          this.$route.name == 'subscribe' ? true : false
        )
      }
    }
  },

  activated() {
    if (sessionStorage['loadHomeUpdate']) {
      // 刷新当前列表数据
      this._loadHome()
      sessionStorage.removeItem('loadHomeUpdate')
    }
    // keep-alive 页面激活时，如果数据已存在，延迟执行 autoShowShop
    // 延迟执行确保 checkAndLoadDateData 触发的数据更新已完成
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.currdataFilter && Object.keys(this.currdataFilter).length) {
          this.autoShowShop()
        }
      }, 500)
    })
  },

  mounted() {
    this.$http.get('member/index?a=shareLogPush', {
      from: `约课列表-曝光-app`,
      from_id: 250326
    })
    // 组件挂载时，如果 home 数据已存在，检查是否需要加载日期数据
    // 如果数据还没准备好，watch home 会处理
    if (
      this.home &&
      Object.keys(this.home).length &&
      this.dayinfo &&
      this.dayinfo.length
    ) {
      this.checkAndLoadDateData()
    }
  },

  destroyed() {},

  methods: {
    // 是否显示隐藏课程门店
    isShowHiddenCourseShop(shop) {
      return (
        this.hiddenCourseObj[shop['shop_name']] &&
        !this.isShowHiddenCourseShopObj[shop['shop_name']]
      )
    },
    // 查看门店全部教练
    handleShowHiddenCourseSwitch(shop) {
      // console.log('handleShowHiddenCourseSwitch', shop)
      // 使用 Vue.set 确保响应式更新
      this.$set(this.isShowHiddenCourseShopObj, shop['shop_name'], true)
      // this.$forceUpdate()
      this['$http']['get'](
        'member/index?a=shareLogPush',
        {
          from: `约课列表页-点击查看全部门店教练`,
          from_id: 20251230343
        },
        true
      )
    },
    // 是否显示课程
    isShowCourse(course) {
      if (course && course['coachid']) {
        // 如果正在请求新数据，跳过 hiddenCourseObj 的更新，避免旧数据污染
        if (
          !this.isLoadingHome &&
          course['is_need_hide'] == 1 &&
          (!this.hiddenCourseObj[course['shop_name']] ||
            !this.hiddenCourseObj[course['shop_name']].includes(course.image))
        ) {
          // console.log('隐藏课程', course)
          this.hiddenCourseObj[course['shop_name']] = [
            ...(this.hiddenCourseObj[course['shop_name']] || []),
            course.image
          ]
          // console.log('hiddenCourseObj', this.hiddenCourseObj)
        }
        if (
          this.isShowHiddenCourseShopObj[course['shop_name']] ||
          (!this.isShowHiddenCourseShopObj[course['shop_name']] &&
            !course['is_need_hide'])
        ) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    // 检查并加载日期数据（从 watch home 提取的逻辑，确保从其他页面进入时也能触发）
    checkAndLoadDateData() {
      // 要等全局接口请求完当前天全部数据再判断，不然当前天全部数据接口返回可能会慢于第二天数据接口
      // 判断是否需要请求传入日期或第二天数据
      if (this.$store.state.subscribe.initAllShop) {
        // 传入的日期
        if (this.$route.query.day) {
          // 小于当前日期则请求传入日期
          if (
            !sessionStorage['loadQeuryDay'] &&
            new Date() <= new Date(this.$route.query.day.replace(/-/g, '/'))
          ) {
            this.onDateChange(this._getCurDay(this.$route.query.day), true)
            sessionStorage['loadQeuryDay'] = 1
          }
        } else if (!sessionStorage['loadSecondDay']) {
          // 只最开始判断一次
          sessionStorage['loadSecondDay'] = 1
          // 判断当前时间是否超过晚上21点
          const currentHour = new Date().getHours()
          const isAfter9PM = currentHour >= 21
          // const isAfter9PM = currentHour >= 21
          // 如果超过21点且有第二天数据且当前日期是第一天，则请求第二天数据
          if (
            this.currDay.a_day === this.dayinfo[0].a_day &&
            isAfter9PM &&
            this.dayinfo.length > 1
          ) {
            this.onDateChange(this.dayinfo[1], true)
          }
        }
      }
    },
    // 专属训练规划师更换提醒弹窗
    async showCoachChangePop() {
      const now = new Date()
      // 每天弹一次 反馈后不弹
      let mainCoachChangeTipsPop = localStorage.getItem(
        'mainCoachChangeTipsPop'
      )
      if (
        (mainCoachChangeTipsPop &&
          new Date(mainCoachChangeTipsPop * 1).toDateString() ==
            now.toDateString()) ||
        this['$store'].state.user.user.member_state != 1 ||
        this.showPoping
      ) {
        return
      }

      let res = await this.$http.get('member/ChangeApply', {
        a: 'alertApply',
        from_type: '1' // 1 约课页提醒弹窗
      })
      if (res.data.code === 200 && res.data.data.flag === 0) {
        if (this.showPop('mainCoachShow')) {
          this.$http.get('member/index?a=shareLogPush', {
            from: `主责更换提醒弹窗-app-曝光`,
            from_id: 25082190
          })
          localStorage.setItem('mainCoachChangeTipsPop', now.getTime())
          this.coachNew = res.data.data.coach ? res.data.data.coach : {}
          this.coachOld = res.data.data.coach_old ? res.data.data.coach_old : {}
        }
      }
    },
    // 门店列表折叠状态改变 滚动条自动定位到当前展开的门店
    handleCollapseChange(index) {
      if (typeof index !== 'number') return
      this.shopActiveIndex = null
      this.$nextTick(() => {
        setTimeout(() => {
          const shopTitleElements = document.querySelectorAll(
            '.shop-list .van-collapse-item'
          )
          const targetElement = shopTitleElements[index]
          // 如果当前门店标题元素不在屏幕的可视区域 则滚动到当前门店
          // 如果当前门店标题元素不在屏幕的可视区域 则滚动到当前门店
          if (targetElement) {
            // 获取目标元素的标题部分（van-collapse-item__title）
            const titleElement = targetElement.querySelector(
              '.van-collapse-item__title'
            )
            if (titleElement) {
              // 根据标题元素计算目标元素相对于视口的位置
              const rect = titleElement.getBoundingClientRect()
              // 顶部日期栏高度
              const WeDateTabWrapHeight =
                document.querySelector('.WeDateTab-wrap').offsetHeight
              // 顶部日期栏+手机顶部导航栏高度
              const topWrapperHeight = this.height + WeDateTabWrapHeight
              const isVisible =
                rect.top >= topWrapperHeight &&
                rect.bottom <= window.innerHeight
              // 如果标题不在可视区域内，则滚动到标题位置
              if (!isVisible) {
                titleElement.scrollIntoView({
                  // block: 'center'
                })
                const currentScrollTop =
                  window.pageYOffset || document.documentElement.scrollTop
                window.scrollTo({
                  top: currentScrollTop - (160 / 375) * window.innerWidth
                  // behavior: 'smooth'
                })
                this.shopActiveIndex = index
              }
            }
          }
        }, 400)
      })
    },
    // 从门店详情页进入约课列表 自动展开标记门店
    autoShowShop() {
      if (sessionStorage['autoShowShopCourseName']) {
        const targetShopName = sessionStorage['autoShowShopCourseName']
        // 根据shopActiveIndex展开的门店 找到对应的index （跟公众号项目不一致 公众号项目算index不包含没有shop_name的门店 这里不渲染 但算index要包含）
        const index = Object.keys(this.currdataFilter).findIndex(
          (v) => this.currdataFilter[v].shop_name == targetShopName
        )
        if (index !== -1) {
          // 等待DOM更新后执行滚动
          this.$nextTick(() => {
            // 延迟执行，确保van-collapse组件完全渲染
            setTimeout(() => {
              try {
                // 查找目标店铺的DOM元素
                const shopElements = document.querySelectorAll(
                  '.shop-list .van-collapse-item'
                )
                if (shopElements[index]) {
                  const targetElement = shopElements[index]
                  // 已展开 直接滚动定位
                  if (index == this.shopActiveIndex) {
                    targetElement.scrollIntoView({
                      // alignToTop: false,
                      // behavior: 'smooth',
                      // block: 'center'
                    })

                    // 等待滚动完成后再往下滑动120px
                    // setTimeout(() => {
                    const currentScrollTop =
                      window.pageYOffset || document.documentElement.scrollTop
                    window.scrollTo({
                      top: currentScrollTop - (160 / 375) * window.innerWidth
                      // behavior: 'smooth'
                    })
                    // }, 50)
                    return
                  }
                  this.shopActiveIndex = null
                  setTimeout(() => {
                    // 滚动到目标元素，使其居中显示
                    targetElement.scrollIntoView({
                      // alignToTop: false,
                      // behavior: 'smooth',
                      block: 'center'
                    })

                    setTimeout(() => {
                      this.shopActiveIndex = index
                      // setTimeout(() => {
                      //   // 再次确保滚动到正确位置
                      //   targetElement.scrollIntoView({
                      //     // alignToTop: false
                      //     // behavior: 'smooth',
                      //     block: 'center'
                      //   })
                      //   // this.shopActiveIndex = index
                      //   // setTimeout(() => {
                      //   //   // 滚动完成后再设置展开状态
                      //   // }, 50)
                      //   const currentScrollTop =
                      //     window.pageYOffset ||
                      //     document.documentElement.scrollTop
                      //   window.scrollTo({
                      //     top:
                      //       currentScrollTop - (120 / 375) * window.innerWidth
                      //   })
                      // }, 400)
                    }, 300)
                  }, 400)
                } else {
                  console.warn('自动展开门店：没有找到目标门店', index)
                }
              } catch (error) {
                console.error('自动展开门店：滚动失败:', error)
              }
            }, 100)
          })
        } else {
          console.warn('自动展开门店：没有找到目标门店', targetShopName)
        }
        sessionStorage.removeItem('autoShowShopCourseName')
      }
    },
    // 获取等级弹窗信息  焕新升级或晋升
    getIsShowGradePop() {
      // 每次进页面只请求一次
      if (sessionStorage['getIsShowGradePop']) return
      this.$http.get('member/MemberGrade?a=promotionPopUp', {}).then((res) => {
        // res.data.data = {
        //   grade: 3,
        //   grade_name: 'V3',
        //   id: 2333,
        //   is_package: 1,
        //   is_pop_up: 1,
        //   type: 2
        // }
        sessionStorage['getIsShowGradePop'] = 1
        // 等级弹窗 type=2 晋升 显示
        if (
          res.data.code === 200 &&
          res.data.data.is_pop_up === 1 &&
          res.data.data.type === 2
        ) {
          this.gardePopInfo = res.data.data
          if (this.showPop('showGradePop')) {
            // 弹窗成功 请求回调
            this.$http.get('member/MemberGrade?a=popUpCallback', {
              id: res.data.data.id,
              position: 'member'
            })
          }
        }
      })
    },
    // 获取勋章弹窗信息
    getIsShowMedalPop() {
      // 每次进页面只请求一次
      if (sessionStorage['getIsShowMedalPop']) return
      this.$http
        .get('member/index?a=alertMedal', { type: 'is_alert' })
        .then((res) => {
          sessionStorage['getIsShowMedalPop'] = 1
          if (res.data.code === 200 && res.data.data) {
            this.medalPopList = res.data.data.medal || []
            // 测试
            // this.medalPopList = [
            //   {
            //     pic: 'https://cdnvue.gymcity.com.cn/uploads/medal26-default',
            //     type: '1',
            //     info: '坚持达人',
            //     all_nums: 1280,
            //     id: 1
            //   },
            //   {
            //     pic: 'https://cdnvue.gymcity.com.cn/uploads/medal26-default',
            //     type: '2',
            //     info: '健身先锋',
            //     all_nums: 856,
            //     id: 2
            //   },
            //   {
            //     pic: 'https://cdnvue.gymcity.com.cn/uploads/medal26-default',
            //     type: '3',
            //     info: '运动之星',
            //     all_nums: 2310,
            //     id: 3
            //   }
            // ]
            //
            if (this.showPop('showMedalPop') && this.medalPopList.length) {
              // 弹窗成功 请求回调
              this.$http.get('member/index?a=shareLogPush', {
                from: `会员勋章新获得弹窗-曝光`,
                from_id: 26012859
              })
            }
          }
        })
    },
    // 展示弹窗-传参通用
    showPop(val) {
      if (!this.showPoping) {
        this[val] = true
        this.showPoping = true
        return true
      }
      return false
    },
    // 关闭弹窗-传参通用
    closePop(val) {
      this[val] = false
    },
    // 获取特殊停卡提醒弹窗状态
    getSpecialStopCardPop() {
      if (sessionStorage.getItem('isGetFbuClassOver')) {
        // 已经获取过
        return
      }
      this.$http.get('member/index?a=isFbuClass').then((res) => {
        if (res.data.code === 200 && res.data.data == 1) {
          if (this.showPop('showSpecialStopCardPop')) {
            // 展示过弹窗后 设置标识 防止重复展示
            sessionStorage.setItem('isGetFbuClassOver', true)
            this.$http.get('member/index?a=shareLogPush', {
              from: `医嘱停卡权益说明弹窗-曝光`,
              from_id: 25070888
            })
          }
        } else {
          // 不需要弹窗 设置标识 防止重复展示
          sessionStorage.setItem('isGetFbuClassOver', true)
        }
      })
    },
    handleDmdImgClick() {
      this.$http._toVueH5Url('cdcard')
    },
    bindBack() {
      this.$http.appBack()
    },
    // 打开APP的约课偏好弹窗
    handleOpenRecoPop() {
      if (this.$betterwe.getAppVersion() < 301) {
        this.$toast('功能暂不支持，请升级APP到最新版')
        setTimeout(() => {
          this.$betterwe.checkAppUpdate()
        }, 1500)
        return
      }
      this.$http.get('member/index?a=shareLogPush', {
        from: `偏好教练推荐-点击约课偏好`,
        from_id: 260707002
      })
      // 弹窗标记位
      this.showCoursePreferencePop = true
      // app 原生设置偏好弹窗保存时触发
      window['onCoursePreferenceSave'] = () => {
        this._loadHome()
        // 刷新推荐教练数据
        this.$refs.recommendCoach?.refreshRecommend()
      }
      this.$betterwe.onAppPageUrlRoute('/gymCoursePreference')
    },
    async getBottomContentHeight() {
      if (this.isApp) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.statusBarHeight = res.statusBarHeight
          this.height = this.statusBarHeight + res.toolsBarHeight
        }
      }
      //  else {
      //   this.statusBarHeight = 40
      //   this.height = this.statusBarHeight + 28
      // }
    },
    //  * 获取当日 格式
    _getCurDay(curDay) {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = curDay ? new Date(curDay.replace(/-/g, '/')) : new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + day,
        week: week[date.getDay()]
      }
      return obj
    },
    // 获取会员协议签署信息
    getAgreementSigning() {
      this.$http
        .get('member/AgreementFaDaDa?a=card_agreement', {})
        .then((res) => {
          if (res.data.code === 200) {
            this.agreementInfo = res.data.data
            // this.agreementInfo['is_reservation_class'] = 1
            // this.agreementInfo['agreement_type'] = 2;
            if (
              [2, 3].includes(this.agreementInfo['is_agreement']) &&
              this.agreementInfo['is_reservation_class'] == 1
            ) {
              // is_agreement 1不需要签署协议；2-协议签署中；3-协议未签署；4-配置问题不签署
              // is_reservation_class  // 1-限制约课，2-不限制约课
              // btw这里初始化时只需要提示整页已被限制约课的情况
              this.showAgreSignPop = true // 显示限制约课整页
            }
          }
        })
    },
    // 点击萌新导师教练头像
    handleHeadBox(id) {
      this.showMxPopId = this.showMxPopId === id ? '' : id
    },
    // 当前shop对象有效键值数 辅助 判断当前门店是否有排课
    showIsClose(shop) {
      let num = 4
      shop['is_class'] === undefined && (num -= 1)
      shop['is_near'] === undefined && (num -= 1)
      return num
    },
    // 开业提示图片点击分享
    handleKyShopImgClickShare(name) {
      this.$http._toVueH5Url(
        this.closeShopShowObject[name].shareParams,
        'push',
        this.closeShopShowObject[name].sharePageTitle
      )
    },
    // 开业提示图片点击打开地图
    handleKyShopImgClick(name) {
      const shopList = this['$store'].state.user.user.shop
      let shop = null
      if (Array.isArray(shopList)) {
        // 作为数组处理
        shop = shopList.find((v) => v.name === name)
      } else if (typeof shopList === 'object' && shopList !== null) {
        // 作为对象处理
        for (const key in shopList) {
          if (shopList.hasOwnProperty.call(shopList, key)) {
            const item = shopList[key]
            if (item.name === name) {
              shop = item
            }
          }
        }
      }
      if (shop) {
        this.$betterwe.jumpRoute(
          `/mapLauncher?latitude=${parseFloat(shop.lat)}&longitude=${parseFloat(
            shop.lon
          )}&title=${shop.name}`
        )
      }
      this.$http.get('member/index?a=shareLogPush', {
        from: `新店开业预热-${name}-查看地址`,
        from_id: 202505301
      })
    },
    // 是否显示闭馆
    showCloseShopTitle(shopName) {
      if (!this.closeShopShowObject[shopName]) {
        return false
      }
      const cur = this.currDay.a_day.replace(/-/g, '/')
      if (this.closeShopShowObject[shopName].startTime) {
        return (
          new Date(cur) >=
            new Date(this.closeShopShowObject[shopName].startTime) &&
          new Date(cur) < new Date(this.closeShopShowObject[shopName].endTime)
        )
      }

      return (
        new Date(cur) < new Date(this.closeShopShowObject[shopName].endTime)
      )
    },
    /**
     * 跳转课程详情
     */
    goDetail(e) {
      // 判断会员协议是否限制约课 还未限制约课 但预约日期超过签署截止日期的弹窗提醒
      if (
        this.agreementInfo &&
        [2, 3].includes(this.agreementInfo['is_agreement']) &&
        this.agreementInfo['is_reservation_class'] === 2
      ) {
        // 将日期字符串转换为Date对象
        const d1 = new Date(
          this.agreementInfo['class_date'].replace(/-/g, '/')
        ).getTime()
        const d2 = new Date(this.currDay.a_day.replace(/-/g, '/')).getTime()
        // 计算两个日期相差的毫秒数
        const diffMs = d2 - d1
        // 将毫秒数转换为天数
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
        if (diffDays >= this.agreementInfo['day']) {
          this.agreementYyxz = true
          this.showAgreSignPop = true
          return false
        }
      }
      // 判断是体验卡会员并没有填写过问卷则弹窗提示
      // if (this.user.user.is_exp_user && this.user.user.is_quesed === 0) {
      //   this.showQuesed = true
      //   return false
      // }
      // 约课
      /**
       * 1017: 不在时间范围
       * 1018: 阶段课程完成
       * 1019: 全课程完成
       * 1021: 只支持预约训练团队教练
       */
      this.$http
        .post2('/User/xgc', { day: this.currDay.a_day, coachid: e.coachid })
        .then((v) => {
          if (v.status === 200) {
            if (v.data.code === 1021) {
              this.$dialog.alert({ message: v.data.msg, title: '约课限制说明' })
            } else {
              this.$store.commit('setDetailData', e)
              this.$store.commit('setCurrDay', this.currDay)
              this.$router.push('/subscribe/detail')
            }
          }
        })
    },
    /**
     * 选择时间段 重新获取 home接口 门店数据
     */
    onTimeSelect(e) {
      this.$toast.loading('按时段筛选中···')
      this.$http.get('member/index?a=shareLogPush', {
        from: `约课列表筛选时段-点击确定`,
        from_id: 202505301
      })
      this._loadHome()
    },
    /**
     * 选择城市  重新获取 home接口 门店数据
     */
    onCitySelect() {
      this.currDay = this.dayinfo[0] // 重置日期
      // 更新对象地址 刷新上方日期组件渲染
      this.currDay = Object.assign({}, this.currDay)
      this._loadHome('region')
      this.isShowCityChangeTipsPop()
    },
    // 是否显示切换城市提醒
    async isShowCityChangeTipsPop() {
      const showCityChangeTipsPop = localStorage.getItem(
        'showCityChangeTipsPop'
      ) // 上次弹的时间
      const now = new Date().getTime()
      const e = this.$store.state.curCity
      // 切换非会籍城市提醒 正式会员 有激活的卡  没有缓存或缓存不是今天（每天只弹一次）
      if (
        e.region_id != this.user.user.region_id &&
        (!showCityChangeTipsPop ||
          new Date(now).toDateString() !==
            new Date(showCityChangeTipsPop * 1).toDateString()) &&
        this.user.user.member_state == 1 &&
        this.user.user.activecardname
      ) {
        // 当前城市
        // 当前卡
        const card = this.user.user.card.find(
          (v) => v.id == this.user.user.user_cardid
        )
        // 卡在使用中 非单店通
        if (card && [1, 2].includes(card.card_state * 1) && card.is_only == 0) {
          const res = await this.$http.get(
            'member/index?a=crossCityCourseLimit',
            {
              city: this.user.user.region_id
            },
            true
          )
          if (res.data.code === 200) {
            if (!res.data.data || res.data.data.length == 0) return

            const cityGroups = {}
            res.data.data.forEach((item) => {
              if (item.num == 0) return
              const key = item.num == -1 ? 'unlimited' : item.num
              if (!cityGroups[key]) {
                cityGroups[key] = []
              }
              cityGroups[key].push(item.name)
            })

            let cityParts = []
            for (let key in cityGroups) {
              const cities = cityGroups[key].join('/')
              if (key == 'unlimited') {
                cityParts.push(cities + '不限次')
              } else {
                cityParts.push(cities + '（共' + key + '次）')
              }
            }
            if (cityParts.length == 0) return
            const cityStr = cityParts.join('、')
            this.cityTipsMessageBoxObj = {
              title: `欢迎来到健萌${e.cityname}`,
              message: `<div><span class='bold-text'>亲爱的会员，您当前享有“全国漫游”权益！</span>您可预约<span class='red-text'>${
                cityStr + '课程'
              }</span>（跨城市上课共同计数）——以自然月为周期，每月1日零时重置，未使用次数不累计不顺延。</div><div class='margin-top-10'><span class='red-text'>*</span>跨城课程同样适用健萌统一的约课、取消规则</div>`,
              confirmText: '知道了',
              confirmFn: () => {
                this.showCityChangeTips = false
              },
              showCancelButton: false
            }
            this.showCityChangeTips = true
            localStorage.setItem('showCityChangeTipsPop', String(now))
            this.$http.get('member/index?a=shareLogPush', {
              from: `约课列表页全国漫游权益弹窗-曝光`,
              from_id: 2026012826
            })
          }
        }
      }
    },
    // 请求Home接口
    _loadHome(type) {
      if (!this.currDay || !this.currDay.a_day) return
      this.showShopSpecState = false
      // 标记正在加载中，此时 isShowCourse 不会更新 hiddenCourseObj
      this.isLoadingHome = true
      // 重新请求重置
      this.hiddenCourseObj = {}
      console.log('重新请求重置', this.hiddenCourseObj)
      this.$http
        .get2('/index/home', {
          day: this.currDay.a_day,
          lat: this.location.lat,
          lng: this.location.lng,
          regionCode: this.$store.state.curCity.region_id,
          h: this.curTime
        })
        .then((res) => {
          // 城市修改跟旧版门店列表联动 所以更新Home数据
          for (let key in res.data) {
            if (res.data[key]['day_info']) {
              // dayInfo.push(res.data[key]['day_info'])
              delete res.data[key]['day_info']
            }
          }
          if (res.data['last_course']) {
            this.$store.commit('course', res.data['last_course'])
          }
          delete res.data['last_course']
          delete res.data['time']
          this.$store.commit('homedata', res.data)
          // 切换城市 显示门店默认第一个
          if (type == 'region') {
            this.shopActiveIndex = 0
          }
          this.$toast.clear()
          this.showShopSpecState = true
          // 数据加载完成后，允许 isShowCourse 更新 hiddenCourseObj
          this.isLoadingHome = false
        })
        .catch((err) => {
          this.$toast.clear()
          // 请求失败也重置标志位
          this.isLoadingHome = false
        })
    },
    /**
     * 日期改变
     */
    onDateChange(obj, showLoading = false) {
      // 点击切换日期
      this.currDay = obj

      // 春节假期 不请求接口
      if (this.showSpringDay) return

      // 检查当前日期是否已经请求过
      const hasRequested = this.requestedDates.has(obj.a_day)

      // 只有当showLoading为true或者currDay.a_day还没请求过才显示loading
      if (showLoading || !hasRequested) {
        this.$toast.loading('数据加载中...')
        this.showShopSpecState = false
      }

      const param = {
        day: obj.a_day,
        lat: this.location.lat,
        lng: this.location.lng,
        regionCode: this.$store.state.curCity.region_id,
        h: this.curTime
      }

      this.$http
        .get2('/index/home', param)
        .then(async (res) => {
          this.$toast.clear()

          // 更新当前天数据
          const currDay = res.data[obj.a_day]
          // 删除day_info
          delete currDay['day_info']

          // 关键修改：同时更新store和组件数据，保持一致性
          const updatedHomeData = { ...this.$store.state.subscribe.home }
          updatedHomeData[obj.a_day] = currDay
          this.$store.commit('homedata', updatedHomeData)

          // 确保组件数据与store数据一致
          // 在home中已经更新了currdata 这里可不赋值
          // this.currdata = currDay

          this.showShopSpecState = true
          // 注意：requestedDates 的记录在 home 计算属性中已完成，这里不需要重复记录
        })
        .catch((err) => {
          this.$toast.clear()
          this.showShopSpecState = true // 确保在错误情况下也能显示状态
        })
    },
    // 会员生日是否弹窗
    getShowBirthdayPop() {
      let showBirthdayPopYear = localStorage.getItem('showBirthdayPopYear') // 已弹次数
      // 测试
      // showBirthdayPopYear = ''; // 已弹次数
      //
      const now = new Date()
      if (!showBirthdayPopYear || showBirthdayPopYear < now.getFullYear()) {
        // 接口隔离弹窗判断 4为会员生日
        this.$http
          .get('member/index?a=activityInfo', { alert_type: 4 })
          .then((res) => {
            if (
              res.data.code === 200 &&
              res.data.data.birthday_info &&
              !this.showPoping
            ) {
              this.memberBirthdayInfo = res.data.data.birthday_info
              this.showPop('showBirthdayPop')
              this.$http.get('member/index?a=shareLogPush', {
                from: `会员生日弹窗-曝光`,
                from_id: 241008
              })
              localStorage.setItem(
                'showBirthdayPopYear',
                `${now.getFullYear()}`
              )
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.subscribe {
  // background-color: #f9f9f9;

  .sub-bar {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 66;
    color: #000000;
    font-weight: 600;

    .title {
      text-align: center;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 18px;
    }

    .back {
      position: absolute;
      left: vw(22);
    }

    .icon-you {
      display: block;
      font-size: 22px;
      transform: rotate(180deg);
    }

    .right {
      font-weight: normal;
      font-size: 15px;
      color: #000000;
      position: absolute;
      right: 16px;
    }
  }

  .sub-swipe {
    width: 100%;
    box-sizing: border-box;
    height: 18.2vw;

    .banner-img {
      width: 100%;
      box-sizing: border-box;
      height: 18.2vw;
    }
  }

  .WeDateTab-wrap {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 9;
    // box-shadow: 0 -1px #ffffff;
  }

  // 深入修改vant样式
  ::v-deep {
    .van-collapse-item__title .van-cell__title {
      font-size: 4vw;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.5);
    }

    .van-collapse-item__title--expanded .van-cell__title {
      color: #000;
    }
  }

  .shop-list {
    .shop-title {
      display: flex;
      align-items: center;

      span.shop-close {
        width: vw(112);
        height: vw(16);
        font-size: vw(10);
        color: #7c7c7c;
        background: #f1f1f1;
        border-radius: vw(4);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: vw(10);
      }

      .shop-close-new {
        padding: 0 vw(4);
        height: 16px;
        box-sizing: border-box;
        background: #dc0050;
        border-radius: 7px 7px 7px 0px;
        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        margin-left: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      span.t-near {
        margin-left: 2.7vw;
        display: block;
        width: 13.9vw;
        height: 4vw;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f7f7f7;
        border-radius: 1.1vw;
        font-size: 2.7vw;
        color: rgba(0, 0, 0, 0.5);
      }
    }

    ::v-deep {
      .van-collapse-item__wrapper {
        overflow: visible;
      }
    }
  }

  .course-list-no {
    text-align: center;
    position: relative;

    .tips {
      width: 100%;
      box-sizing: border-box;
    }

    .mz-tips {
      text-align: left;
      font-size: vw(14);
    }

    .tips-img-btn {
      // background: #f00;
      width: vw(328); // 1个按钮时宽度
      // width: vw(154); // 2个按钮时宽度
      height: vw(55);
      position: absolute;
      top: vw(310);
      left: vw(14);
      z-index: 5;
    }

    .tips-img-btn-2 {
      // background: #0f0;
      width: vw(154);
      position: absolute;
      z-index: 6;
    }
  }
  .shop-hide-switch {
    width: 100%;
    box-sizing: border-box;
    .switch-btn {
      width: vw(343);
      height: vw(36);
      background: #f1f1f1;
      border-radius: vw(18);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: vw(13);
      color: rgba(0, 0, 0, 0.8);
      .btn-coach-imgs {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: vw(10);
        .coach-img {
          width: vw(20);
          height: vw(20);
          border-radius: 50%;
          box-sizing: border-box;
          background: #d8d8d8;
          border: 1px solid #ffffff;
          & + .coach-img {
            margin-left: vw(-6);
          }
        }
      }
      .shop-hide-switch-icon {
        margin-left: vw(10);
        font-size: vw(8);
        color: rgba($color: #050b27, $alpha: 0.5);
        width: vw(14);
        height: vw(14);
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }
    }
    .switch-tips {
      text-align: center;
      font-size: vw(10);
      margin-top: vw(8);
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .dmd-img {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
